module.exports = __webpack_public_path__ + "media/images/christian-matrimony-banner-83a4999f97c2b7887a1b9e62e65dd06a.jpg";